import { createSelector } from 'reselect';
import {
  makeEntityAdapter,
  makeInitialState,
  makeSelectors,
  makeSlice,
} from '../appcontent/appcontent.utils';
import { selectData } from '../data.selectors';
import {
  filterOffers,
  makeDeleteOffer,
  makeFetchOffers,
  makeUpdateOffer,
} from '../offers/offers.utils';

const sliceName = 'data/loyaltyoffers';

const entityAdapter = makeEntityAdapter('distributedOfferId');

export const selectors = makeSelectors(
  'LoyaltyOffers',
  'loyaltyOffers',
  selectData,
  entityAdapter,
);

selectors.selectAllFiltered = createSelector(selectors.selectAll, filterOffers);

selectors.selectTotalLoyaltyOffers = createSelector(
  selectors.selectAllFiltered,
  filteredOffers => filteredOffers.length,
);

selectors.selectLoyaltyOffersSortWithPointsCost = createSelector(
  selectors.selectAllFiltered,
  loyaltyOffers => loyaltyOffers.sort((a, b) => a.pointsCost - b.pointsCost),
);

selectors.selectLoyaltyOffersSortWithPointsCostExpired = createSelector(
  selectors.selectLoyaltyOffersSortWithPointsCost,
  loyaltyOffers => loyaltyOffers.filter(offer => offer.status === 'EXPIRED'),
);

selectors.selectLoyaltyOffersSortWithPointsCostNonExpired = createSelector(
  selectors.selectLoyaltyOffersSortWithPointsCost,
  loyaltyOffers => loyaltyOffers.filter(offer => offer.status !== 'EXPIRED'),
);

selectors.selectSortedLoyaltyOffers = createSelector(
  selectors.selectLoyaltyOffersSortWithPointsCostNonExpired,
  selectors.selectLoyaltyOffersSortWithPointsCostExpired,
  (
    loyaltyOffersSortWithPointsCostNonExpired,
    loyaltyOffersSortWithPointsCostExpired,
  ) => [
    ...loyaltyOffersSortWithPointsCostNonExpired,
    ...loyaltyOffersSortWithPointsCostExpired,
  ],
);

const fetchLoyaltyOffers = makeFetchOffers(
  sliceName,
  () => slice.actions,
  selectors,
  true,
);

export const initialState = makeInitialState(entityAdapter);

export const slice = makeSlice(
  sliceName,
  initialState,
  entityAdapter,
  fetchLoyaltyOffers,
);

const deleteLoyaltyOffer = makeDeleteOffer(sliceName, slice.actions.removeOne);

const updateLoyaltyOfferStatus = makeUpdateOffer(
  sliceName,
  slice.actions.updateOne,
);

export const actions = {
  ...slice.actions,
  fetchLoyaltyOffers,
  deleteLoyaltyOffer,
  updateLoyaltyOfferStatus,
};

export default slice.reducer;
